import * as bill from './BillingFunctions'
import { calculateAge } from '../libraries/HelperFunctions'
import { Appointment } from '@/libraries/ClassDefinitions';

export const AppointmentCodes = [
    {
        name: 'Consultation',
        code: '345',
        price: 152.4,
        category: 'Consultation',
        applicable: false,// no yes maybe
        reasonNotApplicable: '',
        validate: ({ self, newApt, appointments, patient }) => {
            self.reasonNotApplicable = '';
            // Full (345) – max 1/ 24 months period unless >12 months<24 months different diagnosis OR  for inpatient or ED patient
            // bill once per 24 months
            // configure for age
            let patientAge = calculateAge(new Date(patient.dateOfBirth));
            if (patientAge <= 16) {
                self.code = '765';
                self.price = 165.5;
            } else {
                self.code = '345';
                self.price = 152.4;
            }

            let requiredQuestions = [];
            let clear = apptOccurrences(self.code, appointments, newApt.date, 730) == 0;

            if (clear) {
                self.applicable = true;
            } else {
                // second chance? if not in last year
                let maybe = apptOccurrences(self.code, appointments, newApt.date, 365) == 0;

                if (maybe) { // if we have not seen patient in one year
                    if (newApt.patientType == 'ED' || newApt.patientType == 'Inpatient' || 
                    differentDiagnosisA345(newApt.diagnosis,newApt.date,365,730,appointments)) {
                        self.applicable = true;
                    } else {
                        // requiredQuestions.push('newDiagnosis'); // uncomment if diagnosis selection is different
                        self.applicable = newApt.newDiagnosis;
                        if (!self.applicable) self.reasonNotApplicable = 'Patient seen in last 12 - 24 months for same diagnosis';
                    }
                } else {
                    self.applicable = false;
                    self.reasonNotApplicable = 'Patient seen in last 12 months';
                }
            }
            return requiredQuestions;
        },

    },
    {
        name: 'Limited Consultation',
        code: '745',
        price: 99.30,
        category: 'Consultation',
        applicable: false,
        reasonNotApplicable: '',
        validate: ({ self, newApt, appointments }) => {
            // must be referred back and have had care by another MD in the interim
            // we have seen patient before AND seen another doctor 
            self.reasonNotApplicable = ''; // clear
            if (appointments.length == 0) { // seen patient before
                self.applicable = false;
                self.reasonNotApplicable = 'Patient not seen previously';
                return [];
            } else {
                self.applicable = newApt.seenAnotherDoctor;
                if (!self.applicable) self.reasonNotApplicable = 'Patient has not seen another physician in the interim';
                return ['seenAnotherDoctor'];
            }

        },
    },
    {
        name: 'Medical Specific Assessment',
        code: '343',
        price: 77.55, // if updating prices, disease prem hardcodes these numbers
        applicable: false,
        reasonNotApplicable: '',
        validate: ({ self, newApt, appointments }) => {
            // Medical Specific Assessment (343) – max 1/ yr unless second unrelated diagnosis, then 2/yr OR if >90 days and assessment for hospital admission
            // once per year unless either second diagnosis, 
            // in which case 2 per year, or if its more then 90 days AND assessed for hospital admission
            self.reasonNotApplicable = ''; // clear 
            if (apptOccurrences('343', appointments, newApt.date, 90) > 0) { // work backwards
                self.applicable = false; // cannot bill at all
                self.reasonNotApplicable = 'Patient was seen less than 90 days ago.'
                return [];

            } else if (apptOccurrences('343', appointments, newApt.date, 365) == 1) {
                // if 1 apt in last year, and diff diagnosis, we good
                const newDiagnosis = differentDiagnosisGeneric('343',newApt.diagnosis, newApt.date,0, 365,appointments);
                self.applicable = newDiagnosis; // prev was = newApt.newDiagnosis;
                if (!self.applicable) self.reasonNotApplicable = 'Patient is seen in last year with same diagnosis';
                // return ['newDiagnosis'];

            } else {

                let occurencesOf341 = apptOccurrences('341', appointments, newApt.date, 365);
                let occurencesOf343 = apptOccurrences('343', appointments, newApt.date, 365);
                let moreThan4Times = occurencesOf341 + occurencesOf343 >= 4;
                if (moreThan4Times) {
                    self.applicable = false;
                    self.reasonNotApplicable = '343 and 341 in conjunction cannot be billed more then 4 times per year';
                    return [];
                } else {
                    self.applicable = (apptOccurrences('343', appointments, newApt.date, 365) == 0);
                    if (!self.applicable) self.reasonNotApplicable = 'Patient is seen in last year.'
                    return [];
                }
            }
        }
    }, {
        name: 'Complex medical specific re-assessmet',
        price: 68.90,
        code: '341',
        applicable: false,
        reasonNotApplicable: '',
        validate: ({ self, newApt, appointments }) => {
            // max of 4/yr
            // 341 + 343 <= 4
            let occurencesOf341 = apptOccurrences('341', appointments, newApt.date, 365);
            let occurencesOf343 = apptOccurrences('343', appointments, newApt.date, 365);
            self.applicable = (occurencesOf341 + occurencesOf343) <= 4;
            if (!self.applicable) self.reasonNotApplicable = '343 and 341 in conjunction cannot be billed more then 4 times per year'
            return [];
        }
    },
    {
        name: 'Medical specific re-assessment',
        code: '340',
        price: 59.55,
        applicable: false,
        reasonNotApplicable: '',
        validate: ({ self, appointments, newApt }) => {
            // max of 2/ yr
            self.applicable = apptOccurrences(self.code, appointments, newApt.date, 365) < 2;
            if (!self.applicable) self.reasonNotApplicable = 'Max of two per year reached';
                

        }
    },
    {
        name: 'Partial assessment',
        price: 36.25,
        code: '348',
        applicable: true,
        reasonNotApplicable: '',
        validate: ({ self, newApt, appointments }) => {
            // always applicable, set to true by default
        },
    },


];

/**
 * Get the absolute number of days between 2 date strings
 * @param {String} date1 date in the format yyyy-mm-dd as a string
 * @param {String} date2 date in the format yyyy-mm-dd as a string
 * @returns 
 */
function getDaysBetweenDates(date1, date2) {
    const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day

    // Parse the dates
    const [year1, month1, day1] = date1.split('-').map(Number);
    const [year2, month2, day2] = date2.split('-').map(Number);

    // Create Date objects
    const startDate = new Date(year1, month1 - 1, day1);
    const endDate = new Date(year2, month2 - 1, day2);

    // Calculate the difference in days
    const diffDays = Math.round(Math.abs((startDate - endDate) / oneDay));
    console.log('D', diffDays)
    return diffDays;
}


/**
 * Get the number of times a certain code (i.e '345') has been billed within
 * a certain number of days. 
 * @param {String} codeNumber last 3 digits of code i.e -> 345
 * @param {Array<Appointment>} appointments all of the relevant patients appointments (NOT registration or rtp)
 * @param {String} newAptDate the date the new appointment is being billed for 
 * @param {Number} numberOfDays the number of days we are checking
 * @returns {Number} the number of occurences of the string
 */
function apptOccurrences(codeNumber, appointments, newAptDate, numberOfDays) {
    return appointments.filter(apt => {
        let hasCode = apt.codes.filter(code => code.substring(1) == codeNumber).length > 0;
        let inTimeFrame = getDaysBetweenDates(apt.date, newAptDate) <= numberOfDays;
        return hasCode && inTimeFrame;
    }).length;
}

/**
 * Get appointments with a code between 2 numbers of days
 * @param {String} codeNumber 
 * @param {Array<Appointment>} appointments 
 * @param {String} newAptDate 
 * @param {number} minDays 
 * @param {number} maxDays 
 * @returns {Array<Appointment>} all valid appointments
 */
function getAptsWithCodeBetweenDates(codeNumber, appointments, newAptDate, minDays, maxDays){
    return appointments.filter(apt => {
        let hasCode = apt.codes.filter(code => code.substring(1) == codeNumber).length > 0;
        const numberOfDays = getDaysBetweenDates(newAptDate, apt.date);
        const inTimeFrame = (numberOfDays > minDays && numberOfDays < maxDays);
        return hasCode && numberOfDays;
    });
}


/**
 * Determine if diff diagnosis for A345. Considers 765 == 345
 * @param {String} currentDiagnosis 
 * @param {String} newAptDate 
 * @param {number} minDays 
 * @param {number} maxDays 
 * @param {Array<Appointment>} appointments 
 * @returns {boolean} true if all diagnosis different, false if there exists 1 same as current
 */
function differentDiagnosisA345(currentDiagnosis, newAptDate, minDays, maxDays, appointments){
    if (!currentDiagnosis) return false;
    let relevantAppts345 = getAptsWithCodeBetweenDates('345', appointments, newAptDate, minDays, maxDays);
    let relevantAppts745 = getAptsWithCodeBetweenDates('765', appointments, newAptDate, minDays, maxDays);
    const relevantAppts = relevantAppts345.concat(relevantAppts745); // add appts from 745 and 345 to handle age edge cases
    let foundViolation = false;
    relevantAppts.forEach(apt => {
        if (apt.diagnosis == currentDiagnosis) foundViolation = true;
    })
    return !foundViolation;
}

/**
 * Determine if diff diagnosis for code specified
 * @param {String} codeNum 
 * @param {String} currentDiagnosis 
 * @param {String} newAptDate 
 * @param {number} minDays 
 * @param {number} maxDays 
 * @param {Array<Appointment>} appointments 
 * @returns {boolean} true if all diagnosis different, false if there exists 1 same as current
 */
function differentDiagnosisGeneric(codeNumber, currentDiagnosis, newAptDate, minDays, maxDays, appointments){
    if (!currentDiagnosis) return false;
    const relevantAppts = getAptsWithCodeBetweenDates(codeNumber, appointments, newAptDate, minDays, maxDays);
    let foundViolation = false;
    relevantAppts.forEach(apt => {
        if (apt.diagnosis == currentDiagnosis) foundViolation = true;
    })
    return !foundViolation;
}
export const CodePrefixes = {
    regular: 'A',
    inpatient: 'C',
    unscheduled: 'U',
    emergency: 'K',
}
